export const translate = (string: string): string => {
    return string
}